import React from 'react';
import '../styles/workprocess.css';

const WorkProcess = () => {
  return (
    <section className="py-5 bg-white" id="workprocess">
      <div className="container">
        <h2 className="display-5 fw-bold text-center mb-5">
          Arbeitsweise & Vorteile
        </h2>

        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <p className="lead lead-intro">
              Effizient, transparent und digital. <br />Das ist unser Anspruch an moderne Rechtsberatung. Von der ersten Kontaktaufnahme bis zur Fallbearbeitung begleiten wir Sie strukturiert und verständlich – Schritt für Schritt.
            </p>
          </div>
        </div>

        <div className="row text-center">
          <div className="col-md-4 mb-4">
            <i
              className="bi bi-lightning-charge-fill text-primary"
              style={{ fontSize: '3rem' }}
            ></i>
            <h5 className="mt-3 fw-semibold">Agile Beratung</h5>
            <p>
              Schnelle Entscheidungen & direkte Reaktion auf aktuelle Entwicklungen – wir beraten flexibel und lösungsorientiert.
            </p>
          </div>
          <div className="col-md-4 mb-4">
            <i className="bi bi-globe text-success" style={{ fontSize: '3rem' }}></i>
            <h5 className="mt-3 fw-semibold">Ortsunabhängig</h5>
            <p>
              Ob im Büro, unterwegs oder zu Hause – Ihre Kanzlei ist nur einen Klick entfernt. Immer erreichbar, wo Sie sind.
            </p>
          </div>
          <div className="col-md-4 mb-4">
            <i className="bi bi-chat-dots text-danger" style={{ fontSize: '3rem' }}></i>
            <h5 className="mt-3 fw-semibold">Immer für Sie da</h5>
            <p>
              Ihr direkter Draht zu uns. Per E-Mail, Chat oder Videocall. Gerne auch vor Ort. Modern, schnell und persönlich.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkProcess;
